import debug from 'debug';
export var LogLevels;
(function (LogLevels) {
    LogLevels["DEBUG"] = "DEBUG";
    LogLevels["INFO"] = "INFO";
    LogLevels["WARN"] = "WARN";
    LogLevels["ERROR"] = "ERROR";
})(LogLevels || (LogLevels = {}));
const COLOURS = {
    [LogLevels.DEBUG]: 'gray',
    [LogLevels.INFO]: 'blue',
    [LogLevels.WARN]: 'pink',
    [LogLevels.ERROR]: 'red'
};
class Logger {
    constructor() {
        this.debugInstances = {};
    }
    // currently here for backwards compatibility
    static get LEVEL_DEBUG() {
        return LogLevels.DEBUG;
    }
    static get LEVEL_INFO() {
        return LogLevels.INFO;
    }
    static get LEVEL_WARN() {
        return LogLevels.WARN;
    }
    static get LEVEL_ERROR() {
        return LogLevels.ERROR;
    }
    debug(tag, message) {
        this.log(tag, message, LogLevels.DEBUG);
    }
    info(tag, message) {
        this.log(tag, message, LogLevels.INFO);
    }
    warn(tag, message) {
        this.log(tag, message, LogLevels.WARN);
    }
    error(tag, message) {
        this.log(tag, message, LogLevels.ERROR);
    }
    log(tag, message, level) {
        const debugInstance = this.retrieveDebugInstance(tag, level);
        debugInstance(level, message);
    }
    retrieveDebugInstance(tag, level) {
        const moduleName = window['APPLOVIN_MODULE_NAME'];
        const namespace = `AppLovin:${moduleName}:${tag}`;
        let instance = this.debugInstances[namespace];
        if (!instance) {
            instance = debug(namespace);
            this.debugInstances[namespace] = instance;
        }
        // HACK: to support manually setting color of namespace
        instance.color = COLOURS[level];
        return instance;
    }
}
export default new Logger();
//# sourceMappingURL=Logger.js.map